<template>
  <ul id="list-tasks">
    <li>
      <div class="oblea" @click="selectItem">
        <div id="imagenProductoContainer">
          <img v-show="item.EsPromo"  style="position: absolute; width: 30px; left: 5px; top: 5px; z-index: 1; display: block;"  src="/dist/icon_promo.png"   />
          <img id="check" src="/dist/icon-check.png"  v-show="item.showCheck" />
          <div :id="`semaforo${semaforoVal}`" v-show='item.ManejaStock'> </div>
          <img id="imagenPlaceholder" src="/dist/progress-item.gif"  v-show='imagenProducto == null'  style="width:40px; height:40px;" />
          <img id="imagenProducto" :src="imagenProducto" :title="item.Nombre"  v-show='imagenProducto != null'/>
        </div>
        <p id="labelProducto">{{item.Nombre}}</p>
        <p id="labelPrecioAnt" v-if='showNombre && (item.PrecioOferta > 0)'>${{precioOferta | formatMoney}}</p>
        <p id="labelPrecio" v-if='showNombre'>${{precio | formatMoney}}</p>
      </div>
    </li>
  </ul>
</template>


 
<script>
  import axios from 'axios'

  export default {
    name: 'item-realizar-pedido',
    props: ['item'],
    data() {
      return {
        // imagenProducto: null,
      }
    },

    computed: {

      semaforoVal() {
        var actual = Number(this.item.StockActual)
        var minimo = Number(this.item.StockMinimo) 
        if (actual > minimo)   
        {
          return 'V';
        }
        else if ((0 < actual) && (actual <=minimo) )
        {
          return 'A';
        }
        else if (actual <= 0)
        {
          return 'R';
        }
      },

      showNombre() {
        if ((this.$store.state.pedido.seleccion == 1) || (this.$store.state.pedido.seleccion == 2))
        {
          return false;
        }
        else
        {
          return true;
        }
      },

      precio() {
          if (this.item.PrecioOferta < 1) {
            return this.item.Precio * (1 + (this.item.PorcentajeImpuesto/100))
          }
          else {
            return this.item.PrecioOferta * (1 + (this.item.PorcentajeImpuesto/100))
          }  
      },

      precioOferta() {
        return this.item.Precio * (1 + (this.item.PorcentajeImpuesto/100))
      },

      imagenProducto() {
        if ((this.item.ImagenUrl != null) && (this.item.ImagenUrl != '')) {
          return this.item.ImagenUrl
        }
        else {
          return '/dist/placeholder-producto.png'
        }
      }, 

    },

    watch: {
      item: {
        immediate: true,
        handler  () {
        }
      }
    },

    methods: {
      selectItem () {
         this.$emit('setItem', this.item.Id);
      }
    },

    created () {
    //   console.log("*****************111*******************")  
    //   console.log(this.item)
    },

   }
</script>



<style scoped>


#semaforoV {
    width: 10px; 
    height: 15px;
    display: block;
    border-radius: 100%;
    background: #4CD964;
    position: absolute;
    width: 15px;
    left: 115px;
    top: 100px;
    z-index: 2;
    display: block;
   }


  #semaforoA {
    width: 10px; 
    height: 15px;
    display: block;
    border-radius: 100%;
    background: #FFF242;
    position: absolute;
    width: 15px;
    left: 115px;
    top: 100px;
    z-index: 2;
    display: block;
  }
  
  

  #semaforoR {
    width: 10px; 
    height: 15px;
    display: block;
    border-radius: 100%;
    background: red;
    position: absolute;
    width: 15px;
    left: 115px;
    top: 100px;
    z-index: 2;
    display: block;
  }



#check{
    position: absolute;
    width: 20px;
    left: 117px;
    top: 5px;
    z-index: 1;
    display: block;
  }


#imagenProductoContainer{
    width: 110px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border-width: 1px;
    border: 1px solid #dddddd;
    padding: 10px 15px 10px 15px;
    box-shadow: 4px 4px 7px #dddddd;
  }


#imagenProducto{
    position: relative;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
    display: block;
    border-radius: 10 px;
  }


 * {
   margin:  0;
   padding: 0;
  }


  li {
   float: left;
   display: block;
   padding: 10px;
   text-decoration: none;
  }

.oblea{
    position: relative;
    width: 130px;
    height: 185px;
    background: #ffffff;
  }

  #imagenProductoContainer:hover{
    cursor: pointer;
    background: #f9f9f9;
  }

#labelProducto{
  margin-top: 8px;
  text-align: center;
  font-size:10px;
  font-weight: 500;
  background-color: #ffffff;
  color: #4969B2;
  }

#labelPrecio{
  margin-top: 1px;
  text-align: center;
  font-size:13px;
  font-weight: 600;
  background-color: #ffffff;
  color: #F7A541;
  }

#labelPrecioAnt{
  margin-top: 1px;
  text-align: center;
  text-decoration-line: line-through;
  font-size:13px;
  font-weight: 400;
  background-color: #ffffff;
  color: #999999;
  }


 </style>



// WEBPACK FOOTER //
// src/components/views/realizarPresupuesto/itemRealizarPresupuesto.vue